export default __webpack_public_path__ + "static/media/purgeCache.edfe7efc.svg";